module.exports = __webpack_public_path__ + "img/cases-brand-tommee-lazyload-71.d003d292.jpg";